// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoHero_wrapper__jZzH5","video":"VideoHero_video__nlTQI","hero":"VideoHero_hero__Y0HQT","button":"VideoHero_button__1Dgdo"};